import React, { useState, useEffect } from "react";
import MultiselectCheck from "../Components/MultiselectCheck";
import Button from "../Components/Button";
import { connect, useSelector } from "react-redux";
import { languages } from "../../../store/features/translation/Languages";
import { currentLang } from "../../../store/features/translation/selectors";
import { logEvent_ } from "../../../helpers/analytics";

const Fith = (props) => {
	const currentLanguage = useSelector(currentLang);
	const [options, setOptions] = useState([]);
	const tripAttributes = useSelector((state) => state.map.tripAttributes);
	const [options2, setOptions2] = useState([]);
	const [state, setState] = useState(options[0]);
	const [state2, setState2] = useState(options2[0]);
	const handleSelect = (option) => {
		setState(option);
	};
	const handleSelect2 = (option) => {
		setState2(option);
	};
	const handleBack = () => {
		props.handleBack({
			step: 5,
		});
	};
	const handleNext = () => {
		logEvent_("react_tripwiz_stepstyle_nextbtn_pressed");

		props.handleNext({
			step: 5,
			tags: [state, state2],
		});
	};
	useEffect(() => {
		let categories = Object.keys(tripAttributes);
		let versions = tripAttributes[categories[2]].Values;
		let versions2 = tripAttributes[categories[3]].Values;
		setOptions(versions);
		setOptions2(versions2);
		setState(
			props.state?.Attributes ? props.state?.Attributes[0] : versions[0]
		);
		setState2(
			props.state?.Attributes ? props.state?.Attributes[1] : versions2[1]
		);
	}, [tripAttributes, props.state, props.finished]);
	return (
		<>
			<div className={props.visible ? "pb-4" : "d-none"}>
				<div
					className={
						props.visible
							? "px-0 d-flex flex-column justify-content-space-between step-body"
							: "d-none"
					}
					style={{
						width: 384,
						marginBottom: 40,
					}}
				>
					<div>
						<h3
							className="my-2 dromon-l"
							style={{ fontSize: 15, color: "rgb(143, 150, 167)" }}
						>
							Creating a New Trip
						</h3>
						<h2 className="my-4" style={{ fontSize: 22, color: "#222c4b" }}>
							{languages[currentLanguage]["trip_attr_exploration"]}
						</h2>
						<div>
							{options.map((option) => (
								<MultiselectCheck
									handleSelect={() => handleSelect(option)}
									text={
										languages[currentLanguage][option.replaceAll(":", "_")]
											? languages[currentLanguage][option.replaceAll(":", "_")]
											: option
									}
									key={option}
									selected={state === option}
								/>
							))}
						</div>
					</div>
					<div>
						<h2 className="my-4" style={{ fontSize: 22, color: "#222c4b" }}>
							{languages[currentLanguage]["trip_attr_style"]}
						</h2>
						<div>
							{options2.map((option) => (
								<MultiselectCheck
									handleSelect={() => handleSelect2(option)}
									text={
										languages[currentLanguage][option.replaceAll(":", "_")]
											? languages[currentLanguage][option.replaceAll(":", "_")]
											: option
									}
									key={option}
									selected={state2 === option}
								/>
							))}
						</div>
					</div>
				</div>
				<div
					style={{ width: 384 }}
					className="d-flex flex-row justify-content-between px-0"
				>
					<Button text="Back" handleBack={handleBack} />
					<Button
						text={languages[currentLanguage]["common_next"]}
						next
						handleNext={handleNext}
					/>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Fith);
